import { useAppToDatabaseRename } from 'components/hooks'
import paths from 'paths'
import { AppManagementArea } from 'paths/link'
import { Navigate, useParams } from 'react-router-dom'

type RedirectParams = {
  area?: AppManagementArea
}

export default function AppManagementRouterRedirect({
  area = 'connect',
}: RedirectParams) {
  const params = useParams<{
    organizationSlug?: string
    appSlug: string
    userId?: string
  }>()

  const { isRenamed } = useAppToDatabaseRename()

  return (
    <Navigate
      to={paths.appManagement({
        ...params,
        appSlug: params.appSlug || '',
        tenantId: params.userId,
        area,
        isRenamed,
      })}
      replace
    />
  )
}
